/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/filters/invOnHand.ts" />

module Meevo.Plugins.InventoryReturns {
    "use strict";

    import IInventoryReturn = Meevo.Model.IInventoryReturn;

    export class InventoryReturnsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        private isSameDay: boolean;
        public searchResultItemTemplate = '{{distributor.displayName}}, {{totalReturns}}';
        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected params: Meevo.Plugins.InventoryReturns.IParams,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $timeout: angular.ITimeoutService,
            protected $translate: ng.translate.ITranslateService,
            protected $filter: angular.IFilterService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

            this.initializeSections();
        }

        initializeContext(): void {
            this.isSameDay = true;
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.inventoryReturn;
            this.buildCrudSecurityKeys(this.securityKeys.INVENTORY_RETURNS_TAB_MAIN);
            this.sectionTemplatePath = 'app/plugins/inventoryReturns/sectionViews/';
            this.entityType = 'InventoryReturn';
        }

        initializeSections(): void {
            this.initializeContext();

           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INVENTORY_RETURNS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
               this.sections.push(new MainSection(0, 'SECTION_MAIN', 'main.html', true, false, this.baseEndpoint, '',
                   this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.InventoryReturnMain, this.appSettings, this.params, this.modalService, this.busyService, this.$translate,
                   this.$filter, this.securityKeys.INVENTORY_RETURNS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        delete(): void {
            this.modalService.warning(this.deleteConfirmationMessageKey, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then(() => {
                    this.busyService.start();
                    this.dataService.delete(this.appSettings.API_ENDPOINTS.inventoryReturn,
                        new Guid(this.selectedSection.model.id),
                        this.selectedSection.model.entityVersion)
                        .then(() => {
                            this.deactivate();

                            // initiate search (in order to avoid an ability to select deleted item)
                            this.$timeout(() => {
                                let button = angular.element('#js-inventory-returns-search-button');

                                if (button.length) {
                                    button.click();
                                }
                            }, 0);
                        })
                        .finally(() => {
                            this.busyService.stop();
                        });;
                });
        }
        get showDelete(): boolean {
            return super.showDeleteLogic() && this.isSameDay;
        }

        initializeForEdit(): void {
            super.initializeForEdit();

            this.dataService.customMethodData(`api/${this.appSettings.API_ENDPOINTS.inventoryReturn}/${this.itemId}/isSameDate`, 'GET', null)
                .then((response) => {
                    this.isSameDay = response.data;
                });
        }

        showInformation(prod: any) {
            let modalOptions : Meevo.Plugins.Product.ProductInfoModalOptions = {
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.InventoryReturns,
                productId: prod.product_TId,
                variantId: prod.variant_TId,
                productInventoryTypeEnum: prod.productInventoryType
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            };
            return this.modalService.showCustom(options);
        }

        evaluateExpirationDate(response): any[] {
            let filter: any = this.$filter;
            let meevoDate = filter('meevoDateFilter');
            let today = moment().startOf('day');
            response.forEach(li => {
                if (li.expirationDate) {
                    li.isExpired = moment(li.expirationDate).isBefore(today);
                    li.expirationDateDisplay = `${this.$translate.instant('LABEL_EXPIRATION_DATE_PREFIX')}${meevoDate(li.expirationDate)}` + (li.isExpired ? ` (${this.$translate.instant('LABEL_EXPIRED')})` : '');
                }
                else {
                    li.isExpired = false;
                    li.expirationDateDisplay = null;
                }
            });
            return response;
        }
    }
}